import { render, staticRenderFns } from "./TeacherMarksRootView.vue?vue&type=template&id=1ad2a41f"
import script from "./TeacherMarksRootView.vue?vue&type=script&lang=js"
export * from "./TeacherMarksRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports